import { Theme } from '../types';

export const lightTheme: Theme = {
  primaryColor: '#0d6efd',
  secondaryColor: '#6c757d',
  backgroundColor: '#ffffff',
  textColor: '#212529',
};

export const getThemeColors = (theme: Theme) => ({
  '--bs-primary': theme.primaryColor,
  '--bs-secondary': theme.secondaryColor,
  '--bs-body-bg': theme.backgroundColor,
  '--bs-body-color': theme.textColor,
  '--bs-dark': '#212529',
  '--bs-light': '#ffffff',
});

export const applyTheme = (theme: Theme) => {
  const root = document.documentElement;
  const colors = getThemeColors(theme);
  
  Object.entries(colors).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
};
